import React from 'react';

import styles from './popover_wrapper.module.scss';

type Props = {
  children: React.ReactNode;
};
export class PopoverWrapper extends React.Component<Props> {
  render() {
    return <div className={styles.container}>{this.props.children}</div>;
  }
}
